import { init } from '@rematch/core';
import { models } from './models';
export var store = init({
  models: models,
  plugins: []
});